import React from 'react'
import styles from './styles.module.css'

const ChangelogFilterItem = ({ isChecked, onSelect, filterGroupName, value, children, ...props }) => {
  return (
    <label className={styles.checklistItemLabel}>
      <div className={styles.checklistItemCheckboxContent}>
        <input
          className={styles.checklistInputOption}
          type="checkbox"
          checked={isChecked}
          onChange={event => onSelect(filterGroupName, event.target.value)}
          value={value}
          {...props}
        />
        <span className={styles.checkmark}></span>
      </div>
      {children}
    </label>
  )
}

export default ChangelogFilterItem
